<template>
    <div id="footer" class="footer">
        <div class="container">
            <div class="row">
                <div class="col-md-4 offset-md-4 col-8 offset-2">
                    <div class="footer__logo">
                        <Logo/>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer__background">
            <img src="/images/footer_bg.jpg" style="visibility: hidden;" />
        </div>
    </div>
</template>

<script>
    import Logo from './header/Logo.vue'
    export default {
        name: 'Footer',
        components: {
            Logo
        }
    }
</script>


<style lang="scss">
    @import "../assets/styles/components/footer.scss";
</style>